import React from 'react';
import clsx from 'clsx';

interface TitlePorps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  color?: string;
  className?: string;
}

const Title: React.FC<TitlePorps> = ({ title, subtitle, children, color, className }) => {
  const titleClasses = clsx({
    'text-gray-1': color !== 'white',
    'text-white': color === 'white',
  });

  const subtitleClasses = clsx({
    'text-gray-3': color !== 'white',
    'text-gray-5': color === 'white',
  });

  return (
    <div className={`max-w-sm text-center md:max-w-2xl lg:max-w-3xl ${className} mx-auto mb-6 lg:mb-20`}>
      <h3 className={`${titleClasses} text-h3 mb-4`}>{title}</h3>
      <p className={`${subtitleClasses} text-body`}>{subtitle}</p>
      {children}
    </div>
  );
};

export default Title;
